<div class="value-tile-container">
    <div class="value-box" [style.color]="data && data.color" [style.font-size]="fontSize + 'px'"
        [class.cursor]="!readonly && data && data.value !== null" (click)="onSeriesClick()" (tap)="onSeriesClick()">
        <span>{{data && data.valueText}}</span>
    </div>
</div>